import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { SponsorBannerDetailApi } from '../sponsor-banner-detail/api/sponsor-banner-detail-api';
import { SponsorBannerListApi } from '../sponsor-banner-list/api/sponsor-banner-list-api';

export class SponsorBannerApi {
    constructor(protected baseUrl: string) {
        this.SponsorBannerList = new SponsorBannerListApi(this.baseUrl);
        this.SponsorBannerDetail = new SponsorBannerDetailApi(this.baseUrl);
    }

    public SponsorBannerList: SponsorBannerListApi;
    public SponsorBannerDetail: SponsorBannerDetailApi;

    public deleteSponsorBanner(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.delete(`${this.baseUrl}/sponsor-banners/${id}`), noop);
    }
}
